import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ListChecks } from "lucide-react";
import { requestGuideOpen, sendFirstRunGuideEvent } from "../../store/slices/firstRunGuideSlice";

// Help page button for the "Getting set up" guide. Reopens the pop-up while the
// guide is running, and restarts it if it was skipped with steps still to do.
// Hidden for accounts the guide is finished with (or never applied to).
const SetupGuideButton = () => {
  const dispatch = useDispatch();
  const { visible, restartable } = useSelector((state) => state.firstRunGuide);

  if (!visible && !restartable) return null;

  const open = async () => {
    if (!visible) await dispatch(sendFirstRunGuideEvent("restart"));
    dispatch(requestGuideOpen());
  };

  return (
    <button
      type="button"
      onClick={open}
      title="Setup guide"
      aria-label="Open the setup guide"
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium border border-pink-200 dark:border-pink-500/30 text-pink-600 dark:text-pink-300 hover:bg-pink-50 dark:hover:bg-pink-500/10 transition-colors"
    >
      <ListChecks className="w-4 h-4" />
      Start Guide
    </button>
  );
};

export default SetupGuideButton;
